import React from 'react';
import { Link } from 'react-router-dom';
import { Plus, Send, BarChart2 } from 'lucide-react';
import { StatusBadge } from '../components/StatusBadge';
import { useWorkspace } from '../contexts/WorkspaceContext';
export function Campaigns() {
  const {
    campaigns
  } = useWorkspace();
  return <div className="space-y-6" data-id="element-733">
      <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4" data-id="element-734">
        <div className="min-w-0" data-id="element-735">
          <h1 className="text-2xl font-semibold text-gray-900" data-id="element-736">
            Email Campaigns
          </h1>
          <p className="mt-1 text-sm text-gray-500" data-id="element-737">
            Create, schedule, and send campaigns to your audience.
          </p>
        </div>
        <Link to="/campaigns/new" className="inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded-md hover:bg-blue-700 whitespace-nowrap flex-shrink-0" data-id="element-738">
          <Plus className="h-4 w-4 flex-shrink-0" data-id="element-739" />
          <span data-id="element-740">Create Campaign</span>
        </Link>
      </div>

      <div className="bg-white border border-gray-200 rounded-lg overflow-hidden" data-id="element-741">
        {campaigns.length === 0 ? <div className="p-12 text-center" data-id="element-742">
            <Send className="mx-auto h-12 w-12 text-gray-400" data-id="element-743" />
            <h3 className="mt-2 text-sm font-semibold text-gray-900" data-id="element-744">
              No campaigns found
            </h3>
            <p className="mt-1 text-sm text-gray-500" data-id="element-745">
              Start engaging your audience by creating a campaign.
            </p>
          </div> : <div className="overflow-x-auto" data-id="element-746">
            <table className="min-w-full divide-y divide-gray-200" data-id="element-747">
              <thead className="bg-gray-50" data-id="element-748">
                <tr data-id="element-749">
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-750">
                    Campaign Name
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-751">
                    Status
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-752">
                    Sent/Scheduled
                  </th>
                  <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-753">
                    Recipients
                  </th>
                  <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider whitespace-nowrap" data-id="element-754">
                    Actions
                  </th>
                </tr>
              </thead>
              <tbody className="bg-white divide-y divide-gray-200" data-id="element-755">
                {campaigns.map(campaign => <tr key={campaign.id} className="hover:bg-gray-50" data-id="element-756">
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-757">
                      <div className="text-sm font-medium text-gray-900 truncate max-w-[250px]" data-id="element-758">
                        {campaign.name}
                      </div>
                      <div className="text-xs text-gray-500 truncate max-w-[250px]" data-id="element-759">
                        {campaign.subject}
                      </div>
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap" data-id="element-760">
                      <StatusBadge status={campaign.status} data-id="element-761" />
                      {campaign.status === 'exported' && campaign.sendBucketId && <div className="mt-1" data-id="element-762">
                            <code className="text-xs bg-purple-50 text-purple-700 px-2 py-0.5 rounded whitespace-nowrap" data-id="element-763">
                              {campaign.sendBucketId}
                            </code>
                          </div>}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-764">
                      {campaign.status === 'sent' ? campaign.sentAt : campaign.status === 'exported' ? campaign.exportedAt : campaign.scheduledAt || '-'}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-765">
                      {campaign.recipientCount.toLocaleString()}
                    </td>
                    <td className="px-6 py-4 whitespace-nowrap text-right text-sm font-medium" data-id="element-766">
                      <div className="flex items-center justify-end gap-3" data-id="element-767">
                        {campaign.status === 'draft' ? <Link to={`/campaigns/${campaign.id}/edit`} className="text-blue-600 hover:text-blue-900 whitespace-nowrap" data-id="element-768">
                            Edit
                          </Link> : <Link to={`/campaigns/${campaign.id}/report`} className="text-gray-600 hover:text-gray-900 flex items-center gap-1 whitespace-nowrap" data-id="element-769">
                            <BarChart2 className="h-4 w-4 flex-shrink-0" data-id="element-770" />
                            <span data-id="element-771">Report</span>
                          </Link>}
                      </div>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>}
      </div>
    </div>;
}